import { z } from "zod"

export const tailscaleCapabilityMethods = z.enum(["GET", "POST", "PUT", "DELETE", "*"])

export type TailscaleCapabilityMethods = z.infer<typeof tailscaleCapabilityMethods>
export const tailscaleCapabilitySchema = z.object({
  routes: z
    .array(
      z.object({
        route: z.string(),
        methods: z.array(tailscaleCapabilityMethods),
      })
    )
    .optional(),
})

export type TailscaleCapabilitySchema = z.infer<typeof tailscaleCapabilitySchema>
